module.exports = __webpack_public_path__ + "static/smart-board-903f972a92dc9669ebecad149dbefb17.png";